import { makeAutoObservable } from 'mobx'

import { MONDU_KEY } from 'constants/options.constants'

import { CustomerType } from 'types/customer'

import { CURRENCY_COUNTRY_MAP, MONDU_COUNTRIES } from 'constants/paymentSettingShared.constants'
import {
  StripePaymentMethod,
  StripePaymentMethodConstantDependencies,
  StripePaymentMethodWithTerms,
} from '../../../../interfaces/payment-method-interfaces/StripePaymentMethod'
import { CUSTOMER_TYPES } from '../../sales-team-member/screens/deals/constants'
import { CabinetRootStore } from './cabinetRoot.store'

export class MonduPaymentMethodStore
  implements StripePaymentMethod, StripePaymentMethodWithTerms, StripePaymentMethodConstantDependencies {
  storeName = 'MonduPaymentMethodStore'
  root: CabinetRootStore = null

  constructor(root: CabinetRootStore) {
    this.root = root

    if (!this.root.sellerSettingsStore.item?.id) {
      this.root.sellerSettingsStore.fetchItem(null, { skipErrorNotific: true })
    }

    makeAutoObservable(this)
  }

  isAppActive() {
    return this.root.sellerStore.isAppActive(MONDU_KEY)
  }

  isTermsAccepted() {
    const {
      sellerSettingsStore: { item },
    } = this.root

    return !!item.monduTermsAcceptedAt
  }

  isAvailableForCountryCurrency(countryCode: string, currency: string): boolean {
    return (
      MONDU_COUNTRIES.includes((countryCode || 'DE').toUpperCase()) &&
      CURRENCY_COUNTRY_MAP[currency.toUpperCase()]?.includes(countryCode.toUpperCase())
    )
  }

  isAvailableForPayerType(type: CustomerType): boolean {
    return type === CUSTOMER_TYPES.business
  }

  async acceptTerms() {
    const resp = await this.root.sellerSettingsStore.updateItem(
      { mondu_terms_accepted_at: new Date() },
      I18n.t('react.cabinet.mondu.tc_accepted')
    )

    if (resp.success) {
      this.root.sellerSettingsStore.fetchItem()
    }

    return resp
  }
}
